"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const react_router_1 = require("react-router");
const strings_1 = require("../../../constants/strings");
const uiConstants_1 = require("../../../constants/uiConstants");
const reactErrorBoundary_1 = require("../../../router/reactErrorBoundary");
const zustandStore_1 = require("../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../atoms/button/simpleButton"));
const StyledPaper = (0, material_1.styled)(material_1.Paper)(({ theme }) => ({
    width: '100%',
    height: '100%',
    backgroundColor: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP
        ? theme.palette.tsGoColor.pink
        : theme.palette.hsbcColor.white,
    color: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? theme.palette.tsGoColor.white : theme.palette.hsbcColor.black,
}));
const StyledErrorBox = (0, material_1.styled)(material_1.Box)(({ theme }) => ({
    left: '50%',
    transform: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP
        ? 'translateX(-50%) translateY(-50%)'
        : 'translateX(-70%) translateY(-70%)',
    top: '50%',
    position: 'absolute',
    margin: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? 'inherit' : '0 80px 0 80px',
    padding: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? 'inherit' : '27px 45px',
    border: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? 'none' : '2px solid',
    borderColor: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? 'inherit' : theme.palette.hsbcColor.light_gray,
}));
const ErrorPage = ({ showPageNotFoundMessage = true }) => {
    const navigate = (0, react_router_1.useNavigate)();
    const { setHeaderName } = (0, zustandStore_1.useZustand)();
    const { heading, message } = (0, zustandStore_1.useZustand)(state => state.error);
    (0, react_1.useEffect)(() => {
        setHeaderName(globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? 'Tradeshift Go' : 'HSBC Business Virtual Cards');
    }, [setHeaderName]);
    return ((0, jsx_runtime_1.jsx)(StyledPaper, { children: (0, jsx_runtime_1.jsxs)(StyledErrorBox, { children: [(0, jsx_runtime_1.jsx)("h1", { children: showPageNotFoundMessage ? reactErrorBoundary_1.errorStatusMessages[404] : heading }), globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)("p", { children: showPageNotFoundMessage
                        ? 'You tried to access a page that does not exist. Please make sure you have the correct link.'
                        : message })) : ((0, jsx_runtime_1.jsx)("p", { children: showPageNotFoundMessage ? strings_1.errorStrings.HSBC_PAGE_NOT_FOUND_DESCRIPTION : message })), globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "not-found-button", onClick: () => {
                        void navigate('/wallet');
                    }, color: uiConstants_1.UI_BUTTON_PRIMARY, style: { margin: '10px', position: 'relative', left: '90%', transform: 'translateX(-70%)' }, label: strings_1.errorStrings.HSBC_PAGE_NOT_FOUND_BUTTON })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] }) }));
};
exports.default = ErrorPage;
